import { AuthService } from 'src/app/core/auth/auth.service';
import { Router } from '@angular/router';
import { MainMenuService } from 'src/app/shared/services/mainmenu.service';
import { GotoAction, ModalAction } from 'src/app/shared/models/action';
import { GeneralService } from 'src/app/shared/services/general.service';
import { Injectable } from '@angular/core';
import { SharedController } from 'src/app/shared/shared-controller';
import { FollowService } from 'src/app/shared/services/follow.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RealtorController extends SharedController {

    totalFollowing = 0;

    perfilId = null;
    
    private state = new BehaviorSubject<any>([]);
    state$ = this.state.asObservable();

    constructor(protected mms: MainMenuService,
        protected route: Router,
        protected auth: AuthService,
        protected gs: GeneralService,
        protected fs : FollowService){
        super(mms, route, auth, gs);
            
        this.fs.following$.subscribe(async result => {
            this.totalFollowing = result;
            await this.init();
        });
        
    }

    async init(){

        let state = await this.gs.getSignUpState();
        this.state.next(state);
        this.perfilId = this.gs.getProfiledata()?.perfil_id;

        if(state == 'AccessLoading')
            return;

        if(state == 'AccessAllow'){
            let menu = [
                //new GotoAction('header', 'Home', [this.gs.getBase(), 'home'], { main: true, icon: "home"}, this.route),
                new GotoAction('header', 'Imóveis', [this.gs.getBase(), 'search', 'map'], { main: true, icon: "search"}, this.route),
                new GotoAction('header', 'Empresas', [this.gs.getBase(), 'advertise'], { main: true, icon: "briefcase"}, this.route),
                new GotoAction('header', 'Favoritos', [this.gs.getBase(), 'follow'], { main:true, icon: "heart", badge: this.totalFollowing }, this.route),
                //new ModalAction('user', 'Indicar um amigo', 'IndicateComponent')
            ];
            this.setMainMenu(menu);
        }
        this.loadButtons();

        this.gs.setOptions({headerScrollTop : 50});
    }
   
}